import React from 'react';
import { Route, Redirect } from 'react-router-dom';

const redirectRoutes = [
  <Route
    key="tryout-sukses-ukai"
    exact
    path="/TryOutSuksesUKAI"
    render={(props) => (
      <Redirect
        to={{
          pathname: "/tryout",
          state: { from: props.location },
        }}
      />
    )}
  />
];

export default redirectRoutes; 